














































































































import accounting from 'accounting';
import { mobile, tablet } from 'bowser';
import { Component, Prop } from 'vue-property-decorator';
import { formatter } from '../app.config';
import { showAltapayPaymentWindow } from '../helpers/altapay';
import BaseComponent from './Base';

declare var saleData: any;
declare var altapayPaymentWidget: any;

@Component
export default class Altapay extends BaseComponent {
  @Prop({type: String, required: true}) protected readonly additionalFee: string;
  @Prop({type: Boolean, default: false}) protected readonly paymentChoose: boolean;
  @Prop({type: Boolean, default: false}) protected readonly cardsChoose: boolean;
  @Prop({type: String}) protected readonly cardsImageUrl: string;
  @Prop({type: String}) protected readonly creditCardLabel: string;
  @Prop({type: String}) protected readonly debitCardLabel: string;

  protected PAYMENT_TYPES: { BANKING: string, CARD: string } = {
    BANKING: 'banking',
    CARD: 'card',
  };

  protected CARD_TYPES: { DEBIT: string, CREDIT: string } = {
    DEBIT: 'debit',
    CREDIT: 'credit',
  };

  protected lastValidAmount: string = '';

  // protected paymentWindow: any = null;
  protected cardType: string = this.CARD_TYPES.CREDIT;
  protected paymentType: string = this.PAYMENT_TYPES.BANKING;
  protected showFee: boolean = false;
  protected innerAmount: string = '';

  protected get selectedCardType(): string {
    return this.cardType;
  }

  protected set selectedCardType(type: string) {
    this.cardType = type;
    this.updateAmount(this.innerAmount);
  }

  protected get selectedPaymentType(): string {
    return this.paymentType;
  }

  protected set selectedPaymentType(type: string) {
    this.paymentType = type;

    // this.paymentWindow.options.paymentcollection = 1;
    // if (type === this.PAYMENT_TYPES.BANKING) {
    //     this.paymentWindow.options.paymentcollection = 2;
    // }
    this.updateAmount(this.innerAmount);
  }

  protected transaction: { amount: number, total: number, invoice: string, person: string, comment: string } = {
    amount: 0,
    total: 0,
    invoice: '',
    person: '',
    comment: '',
  };

  protected errors: { amount: string[], invoice: string[], person: string[], gateway: string[] } = {
    amount: [],
    invoice: [],
    person: [],
    gateway: [],
  };

  protected get name(): string {
    return this.transaction.person;
  }

  protected set name(name: string) {
    if (name.length !== 0) {
      this.hideError('person');
      this.transaction.person = name;
    } else {
      this.transaction.person = '';
      this.addError('person', this.t('Please fill in the name'));
    }
  }

  protected get invoice(): string {
    return this.transaction.invoice;
  }

  protected set invoice(invoice: string) {
    this.transaction.invoice = invoice;

    if (invoice === '') {
      this.addError('invoice', this.t('Please fill in invoice or quote reference no. If you have not yet received an invoice or quotation number, simply enter " 123456 " into the required field.'));
    } else if (!/[1-9]+/.test(invoice)) {
      this.addError('invoice', this.t('Invoice number must be at least 4 digits. If you have not yet received an invoice or quotation number, simply enter " 123456 " into the required field.'));
    } else {
      this.hideError('invoice');
      this.transaction.invoice = invoice;
    }
  }

  protected get amount(): string {
    return this.innerAmount;
  }

  protected set amount(amount: string) {
    if (this.isValidAmount(amount)) {
      this.innerAmount = amount;
      this.lastValidAmount = amount;
      this.updateAmount(amount);
    } else {
      // to trigger v-model update
      this.innerAmount = amount;
      this.innerAmount = this.lastValidAmount;
    }
  }

  protected isValidAmount(amount: string): boolean {
    // 1-8 digits optional, dot optional, 1-2 digits
    return /^$|^\d{0,8}(\.\d{0,2})?\.?$/.test(amount);
  }

  protected updateAmount(amount: string): void {
    let parsedAmount: number | any = amount.trim().replace(/,/, '.');
    if (parsedAmount === '') {
      parsedAmount = 0;
      this.addError('amount', this.t('Please fill in the amount'));
    } else if (!isNaN(parseFloat(parsedAmount))) {
      parsedAmount = parseFloat(parsedAmount);
      this.hideError('amount');
    }

    this.showFee = false;
    const additionalFee = parseFloat(this.additionalFee);

    if (additionalFee > 0 && this.cardType !== this.CARD_TYPES.DEBIT) {
      this.transaction.total = parsedAmount + parsedAmount * (additionalFee / 100);
      if (this.transaction.total > 0 && additionalFee > 0) {
        this.showFee = true;
      }
    } else {
      this.transaction.total = this.transaction.amount;
    }

    this.transaction.amount = parseFloat(parsedAmount);
  }

  protected get comment(): string {
    return this.transaction.comment;
  }

  protected set comment(comment: string) {
    this.transaction.comment = comment || '';
  }

  protected get total(): string {
    return formatter.asDecimal(Math.ceil(this.transaction.total * 100) / 100);
  }

  // start processing
  protected start(): void {
    if (!('altapayPaymentWidget' in window)) {
      return;
    }

    const amount = Math.ceil(this.transaction.total * 100);
    const currencyAlpha = saleData.currencyAlpha;
    const orderId = this.transaction.invoice;

    const { firstName, lastName } = this.parsePerson(this.transaction.person);

    const description = {
      invoice: `Invoice or quote reference no: ${orderId}`,
      amount: `Amount ex. fee: ${accounting.formatNumber(this.transaction.amount, 2, '', ',')}`,
      firstName,
      lastName,
      comment: this.transaction.comment ? `${this.transaction.comment}` : ``,
    };

    try {
      altapayPaymentWidget.open(amount, currencyAlpha, orderId, null, description);
    } catch (e) {
      this.addError('gateway', this.t('Sorry, we have a problem with payment gateway. Please try later.'));
    }
  }

  protected parsePerson(person: string): { firstName: string; lastName: string } {
    const personArr = person
        .split(' ')
        .filter((item) => item.length > 1);

    let firstName = '';
    let lastName = '';

    if (personArr[0] && personArr[0].length) {
      firstName = personArr[0];
    }

    if (personArr[1] && personArr[1].length) {
      lastName = personArr[1];
    }

    if (personArr[2] && personArr[2].length) {
      lastName = `${lastName} ${personArr.slice(2).join(' ')}`;
    }

    return {
      firstName,
      lastName,
    };
  }

  protected addError(key: string, error: string): void {
    this.$set(this.errors, key, [error]);
  }

  protected hideError(key: string): void {
    this.$set(this.errors, key, []);
  }

  protected get hasErrors(): boolean {
    return !!Object.keys(this.errors).find((key) => this.errors[key].length > 0);
  }

  protected onSubmit(): void {
    // trigger setters
    this.amount = this.amount;
    this.invoice = this.invoice.trim();
    this.name = this.name.trim();
    this.comment = this.comment.trim();

    if (!this.hasErrors) {
      this.start();
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Altapay.vue